import { Button } from 'components'
import { LMS_URL } from '../../constants'
export const ForwardToLMSPageBtn = () => {
  return (
    <Button
      type="button"
      variant="buttons.primary"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 50,
        flex: '0 0 auto',
      }}
      onClick={(e) => {
        e.preventDefault()
        window.open(LMS_URL, '_blank')
      }}>
      Go to course
    </Button>
  )
}
